export const ERRORS = {
  GUARDIAN: {
    ACTION_INVALID_COLLATERAL_OVERFLOW:
      'Transaction failed validation: it cannot result with Vault collateral being above max threshold. Choose amount of BTC/UNIT which will result in collateral ratio below 1000%',
    UNIT_RESERVE_OUTDATED: 'The reserved Units have already been claimed. Please, retry later.',
  },
} as const;
